import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getFuelVendorDashboard = async (period) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/dashboard/`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: period ? { period } : undefined,
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel vendor dashboard fetch error:", error);
    throw error;
  }
};

export { getFuelVendorDashboard };
